import { DatabaseService } from './database.service';
import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { ObserverService } from './observer.service';

@Injectable()
export class ConnectedAccountService {

    constructor(
        public alertController: AlertController,
        private observerService: ObserverService,
        private databaseService: DatabaseService
    ) { }

    addConnectedAccount(raw_connected_account) {
        return new Promise<void>((resolve, reject) => {
            let connected_account = {};
            connected_account["id"] = raw_connected_account.id;
            connected_account["access_token"] = raw_connected_account.access_token;
            connected_account["refresh_token"] = raw_connected_account.refresh_token;
            connected_account["organisation_title"] = raw_connected_account.organisation_title;
            connected_account["server_name"] = raw_connected_account.server_name;
            connected_account["site_name"] = raw_connected_account.site_name;
            connected_account["user_id"] = raw_connected_account.user_id;
            // TEMPORARY 30/7/25, added v2.8.5
            connected_account['user'] = raw_connected_account.user;
            // END TEMPORARY
            this.databaseService.connected_account
            .add(connected_account)
                .then(() => {
                    this.observerService.publish("connected_account_added", connected_account);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    }

    deleteConnectedAccount(connected_account_id) {
        return new Promise<void>((resolve, reject) => {
            this.databaseService.connected_account
                .delete(connected_account_id)
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    }

    getConnectedAccount(connected_account_id) {
        return new Promise((resolve, reject) => {
            this.databaseService.connected_account
                .get(connected_account_id)
                .then((connected_account) => {
                    resolve(connected_account);
                })
                .catch(() => {
                    reject();
                });
        });
    }

    getConnectedAccounts() {
        return new Promise((resolve, reject) => {
            this.databaseService.connected_account.toArray().then((connected_accounts) => {
                resolve(connected_accounts);
            })
            .catch(() => {
                reject();
            });
        });
    }

    // NOTE: using Dexie.js update rather than delete/add to avoid issues with a connected account being deleted
    updateConnectedAccount(connected_account) {
        return new Promise<void>((resolve, reject) => {
            this.databaseService.connected_account
                .update(connected_account.id, connected_account)
                .then(() => {
                   this.observerService.publish("connected_account_updated", connected_account);
                   resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    }

}